import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import '../../../../styles/styled-components/alert.js';
import '../../../../styles/styled-components/animations.js';
import '../../../../styles/styled-components/box-shadow.js';
import '../../../../styles/styled-components/button.js';
import '../../../../themes/alert.js';
import '../../../../themes/button.js';
import '../../../../themes/checkbox.js';
import '../../../../themes/divider.js';
import '../../../../themes/dropdown.js';
import '../../../../themes/fieldset.js';
import '../../../../themes/input.js';
import '../../../../themes/list.js';
import '../../../../themes/listbox.js';
import '../../../../themes/loader.js';
import '../../../../themes/option.js';
import '../../../../themes/popout.js';
import '../../../../themes/switch.js';
import { lightTheme } from '../../../../themes/themes.js';
import '../../../../themes/tooltip.js';
import '../../../../styles/styled-components/font-face.js';
import '../../../../styles/styled-components/global.js';
import '../../../../styles/styled-components/input.js';
import '../../../../styles/styled-components/list.js';
import { baseListItemStyle } from '../../../../styles/styled-components/listitem.js';
import '../../../../styles/styled-components/media-queries.js';
import '../../../../styles/styled-components/reset.js';
import '../../../../styles/styled-components/outline.js';
import '../../../../styles/styled-components/popout.js';
import '../../../../styles/styled-components/screen-reader.js';
import '../../../../styles/styled-components/switch.js';
import '../../../../styles/styled-components/tooltip.js';
import { BaseListItem } from '../base-listitem/base-listitem.js';

const UnstyledListItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { children, className, ...otherProps } = props;
    return /*#__PURE__*/ React.createElement(BaseListItem, {
        ...otherProps,
        className: classnames({
            'bf-listitem__standard': true,
            [`${className}`]: !!className
        }),
        ref: ref
    }, children);
});
const StyledListItem = styled(UnstyledListItem)`
  ${baseListItemStyle}
  padding: 0;
`;
/**
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listitem_role
 *
 * @param props StandardListItemProps
 * @returns FunctionComponent<StandardListItemProps>
 */ const StandardListItem = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { ...otherProps } = props;
    const themeContext = useContext(ThemeContext);
    return /*#__PURE__*/ React.createElement(ThemeProvider, {
        theme: themeContext || lightTheme
    }, /*#__PURE__*/ React.createElement(StyledListItem, {
        ...otherProps,
        ref: ref
    }));
});

export { StandardListItem };
//# sourceMappingURL=standard-listitem.js.map
